import { AxiosError } from 'axios';
import { GET_COORDINATOR_APPEAL_REVIEW_URL } from '../../constants/apiUrls';
import { GET_COORDINATOR_APPEAL_REVIEW_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface CandidateDetails {
  statutoryName: string;
  nricFin: string;
  citizenship: string;
  schoolName: string;
  indexNo: string;
}

export interface SubjectInfoObject {
  nameDescription: string;
  nameCode: string;
  gradeAlphabetical: string;
  gradeNumerical: string;
  languageMedium: string;
  appealFee: string;
}

export interface SelectedSubjects {
  examYear: string;
  examLevel: string;
  examSeries: string;
  subjectInfo: SubjectInfoObject[];
}

export interface AppealFees {
  gstRegNo: string;
  totalGst: string;
  totalPayable: string;
  gstAbsorbed: string;
  totalPayableFeeExcludingGST: string;
  totalPayableFeeIncludingGST: string;
}

export interface CoordinatorAppealReviewResponse {
  candidateDetails: CandidateDetails;
  selectedSubjects: SelectedSubjects;
  appealFees: AppealFees;
  bankTransferOption: true;
  candidatePayOption: true;
  coordinatorPayOption: true;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  enabled?: boolean;
  uuid: string;
}

export const useGetCoordinatorAppealReview = ({ onSuccess, onError, enabled, uuid }: Input) => {
  const getCoordinatorAppealReview = async () => {
    const res = await axiosClient.get<CoordinatorAppealReviewResponse>(
      GET_COORDINATOR_APPEAL_REVIEW_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(GET_COORDINATOR_APPEAL_REVIEW_QUERY_KEY, getCoordinatorAppealReview, {
    onSuccess,
    onError,
    enabled,
  });
};
